import React, {useState} from "react";
import {useMutation, useQuery} from "@apollo/client";
import {Button, Col, Container, Row} from "react-bootstrap";
import FlashMessage from "../../shared/FlashMessage";
import {saveData} from "../../../helpers/Api";
import PageTitle from "../../../layout/PageTitle";
import {BackButton} from "../../../helpers/ButtonHelper";
import UploadFile from "../../shared/UploadFile";
import {getMeasurementsByIdQuery, getMeasurementsQuery, saveMeasurementMutation} from "./MeasurementQueries";
import {useNavigate, useParams} from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const MeasurementForm = () => {
  const navigate = useNavigate()
  const params = useParams();
  const [flash, setFlash] = useState({});
  const [date, setDate] = useState(new Date());
  const [record, setRecord] = useState({
    id: null,
    date: new Date(),
    details: '',
    image: '',
    weight: '',
    bust: '',
    waist: '',
    arms: '',
    legs: '',
    hips: ''
  })
  const { data, loading, refetch } = useQuery(getMeasurementsByIdQuery, { variables: { id: params.id } })

  if (params.id) {
    if (!record.id && !loading && data) {
      setRecord(data.measurement)
      setDate(data.measurement.date)
    }
  }
  const [saveCall] = useMutation(saveMeasurementMutation, { refetchQueries: [getMeasurementsQuery] })

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: 'saveMeasurement',
      flash_callback: setFlash,
      success: () => {
        if (!params.id)
          navigate(`/my_measurements`)
      }
    })
  }

  return (
    <>
      <Container>
        <PageTitle title='Adauga masuratori' />
        <Row className='d-sm-flex mb-4 mt-4 align-items-start bg-body p-4 rounded shadow bor'>
          {record.id &&
            <Col className='flex-shrink-0 me-2 col-auto p-2'>
              <UploadFile model='measurement' id={record.id} field='image'
                          filePath={record.image} onChange={refetch} />
            </Col>
          }
          <Col sm>
            <form onSubmit={onSubmit}>
              <Row className="mb-2">
                <Col sm>
                  <input type='hidden' name='id' defaultValue={record.id} />

                  <label htmlFor="date">Data</label>
                  <div>
                    <DatePicker selected={new Date(date)} className="form-control"
                                showIcon icon="bi bi-calendar"
                                dateFormat="dd.MM.yyyy"
                                onChange={(date) => setDate(date)}
                                name={"date"}
                    />
                  </div>
                </Col>
                <Col sm>
                  {!record.id &&
                    <>
                      <label htmlFor='image'>Imagine</label>
                      <input name='image' className="form-control" id="image" type='file' />
                    </>
                  }
                </Col>
              </Row>
              <Row className="mb-2">
                <Col sm>
                  <label htmlFor="weight">Greutate</label>
                  <input type='number' step="0.1" name='weight' className="form-control" id="weight"
                         defaultValue={record.weight} />
                </Col>
                <Col sm>
                  <label htmlFor="waist">Talie</label>
                  <input type='number' step="0.1" name='waist' className="form-control" id="waist"
                         defaultValue={record.waist} />
                </Col>
                <Col sm>
                  <label htmlFor="bust">Bust</label>
                  <input type='number' step="0.1" name='bust' className="form-control" id="bust"
                         defaultValue={record.bust} />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col sm>
                  <label htmlFor="hips">Solduri</label>
                  <input type='number' step="0.1" name='hips' className="form-control" id="hips"
                         defaultValue={record.hips} />
                </Col>
                <Col sm>
                  <label htmlFor="arms">Brate</label>
                  <input type='number' step="0.1" name='arms' className="form-control" id="arms"
                         defaultValue={record.arms} />
                </Col>
                <Col sm>
                  <label htmlFor="legs">Picioare</label>
                  <input type='number' step="0.1" name='legs' className="form-control" id="legs"
                         defaultValue={record.legs} />
                </Col>
              </Row>

              <Row className='mb-2'>
                <Col sm>
                  <label htmlFor="details">Note</label>
                  <textarea name='details' className="form-control" id="details" defaultValue={record.details} />
                </Col>
              </Row>

              <Row className="mb-3">
                <FlashMessage flash={flash} buttons={
                  <>
                    <BackButton className='float-end' showText={true} size='md' to='/my_measurements' />
                    <Button type='submit' className='float-end'>Salveaza</Button>
                  </>
                } />
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
      <div className='mb-3'></div>
    </>
  )
};

export default MeasurementForm;
